import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { GradienButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_GRADIEN_BUTTONS, RAISED_GRADIEN_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedGradienButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={GradienButton} span={RAISED_GRADIEN_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn color="primary-gradien" id="Tooltip-75" className="btn-pill btn-air-primary">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-75" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary-gradien btn-air-primary</ToolTip>
          {RAISED_GRADIEN_BUTTONS_LIST.map((data, index) => (
            <CommonRaisedButton key={index} item={data} />
          ))}
        </CardBody>
      </Card>
    );
};

export default RaisedGradienButtons;
